export enum CrashContactStatus {
  NOT_CONTACTED = 'notContacted',
  CONTACTED = 'contacted',
  UNREACHABLE = 'unReachable',
  NOT_APPLICABLE = 'notApplicable',
}

export enum CrashIncidentStatus {
  NO_STATUS = 'noStatus',
  CRASH = 'crash',
  NO_CRASH = 'noCrash',
}

export enum CrashUserRespondType {
  CRASH = 'crash',
  NO_CRASH = 'noCrash',
  NO_ACTION = 'noAction',
}

export interface CrashDetectionCase {
  id: string
  crashDetectionCrashInfoId?: string // used in detail
  userRespondType: CrashUserRespondType | null
  userRespondAt?: string
  currentContactStatus: CrashContactStatus | null
  incidentDateTime: string
  policyNumber: string
  fullName: string
  emergencyContactNo: string
  licensePlate: string
  currentIncidentStatus: CrashIncidentStatus | null
  isSendSurveyor: boolean
  detectedDeviceName?: string
  detectedDeviceType?: string
  notificationSendAt?: string
  ownerName: string
  updatedAt: string
  notifyNumber: string | null
  note: string | null
  isViewOnly?: boolean
  latitude?: number
  longitude?: number
  // Backoffice assignment / lock fields (added with assignCrashDetectionOwner API)
  ownerUserId?: string
  ownerEmployeeCode?: string
}

export interface CrashDetectionListResponse {
  data: CrashDetectionCase[]
  meta: {
    totalItems: number
    itemCount: number
    itemsPerPage: number
    totalPages: number
    currentPage: number
  }
}

export interface CrashDetectionDashboardResponse {
  data: {
    totalCaseNotResponse: number
    caseList: CrashDetectionCase[]
  }
  meta: {
    totalItems: number
    itemCount: number
    itemsPerPage: number
    totalPages: number
    currentPage: number
  }
}
